import WidgetModel, { SendDataConfig } from '@mm/state/model/WidgetModel';
import { useViewActions } from '@mm/state/actions/viewActions';
import { StoreState } from '@mm/state/store-interfaces';
import { ReactComponent as ZapierIcon } from 'assets/icons/zapier-logomark.svg';
import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Handle, Position, NodeProps } from 'react-flow-renderer';
import { useSelector } from 'react-redux';
import css from './Zapier.module.css';
import common from '../index.module.css';
import { Count } from '../elements/Count/Count';
import { useOpenOnReady } from '../use-open-on-ready';
import { uniqueId } from 'lodash';

type Props = { className?: string } & NodeProps<{
  widget: WidgetModel;
}>;

export const Zapier: React.FC<Props> = ({
  className,
  data,
  isDragging,
  children,
}) => {
  const widgets = useSelector((state: StoreState) => state.widget.entities);
  const widget = widgets.find(w => w.id === data.widget.id) || data.widget;
  const config = widget.config as Partial<SendDataConfig>;

  const { resourceSubscriptionTriggerName: zapName, firesCount } = config;

  const viewActions = useViewActions();

  const onClick = () => {
    if (isDragging) {
      return;
    }

    viewActions.showSlideoutMenu('zapierIntegrationEditor', {
      widgetId: data.widget.id,
    });
  };

  useOpenOnReady(widget, onClick);

  return (
    <>
      <Handle type="target" position={Position.Top} />
      <div
        className={classNames(className, common.card, css.container)}
        onClick={onClick}
      >
        <div className={css.body}>
          <div className={css.header}>
            <div className={css.icon}>
              <ZapierIcon />
            </div>

            <span className={css.placeholder}>
              Zapier
              <span className={css.subtext}>
                Automatically send data from Customers.ai
              </span>
            </span>

            <div>
              {React.Children.map<ReactNode, ReactNode>(children, child => {
                if (React.isValidElement(child)) {
                  return React.cloneElement(child, {
                    // @ts-ignore onEdit does not seemto be present or types are off in @types/react
                    onEdit: onClick,
                    key: uniqueId(),
                  });
                }
              })}
            </div>
          </div>
          {zapName && (
            <div className={css.info}>
              <span className={css.connectionName}>{zapName}</span>
              <Count
                className={css.firesCount}
                value={`${firesCount || 0} contacts`}
              />
            </div>
          )}
        </div>
      </div>

      <Handle type="source" position={Position.Bottom} />
    </>
  );
};
